export const askEnglish = {
  new_chat: "New chat",
  dock: "Keep beside page",
  overlay: "Show over page",
  use_page: "Use page filters",
  scope: "Ask about",
  page_overview: "Overview",
  page_processes: "Processes",
  page_process: "Process",
  page_team: "Team activity",
  page_session: "Session",
  page_kpis: "Insights",
  from_page: "from {{page}}",
  context_from_page: "Context from {{page}}",
  title_overview: "Ask about your team’s work",
  title_processes: "Find where to look next",
  title_process: "Understand this process",
  title_team: "Explore how your team works",
  title_session: "Understand this session",
  title_kpis: "Understand your KPIs",
  insight: "What explains {{process}}’s share of working time?",
  insight_prompt:
    "What explains {{process}}’s share of observed working time in the key insight? Separate case volume from duration per case. A large time share alone does not establish inefficiency. Cite the evidence and its coverage.",
  changed: "What changed most?",
  periods: "{{current}} vs {{previous}}",
  choose_period: "Choose a complete date range to compare periods.",
  trend_prompt:
    "What changed most between {{current}} and {{previous}}? Use the selected people and processes, retrieving the previous period even when it is outside the current page range. State both periods, observation coverage, and sample sizes. Distinguish changes in activity coverage from changes in how work happens. Cite evidence and say when the data is insufficient.",
  investigate: "Which processes should I investigate first?",
  opportunity: "Where is the biggest opportunity to improve?",
  automation: "Where could AI or automation help most?",
  variation: "Which processes vary most in duration?",
  complexity: "Which processes have the most complex paths?",
  rework: "Where do we see the most repeated work?",
  duration: "What drives duration in {{process}}?",
  steps: "Which steps take the most time?",
  process_people: "How does this process differ across people?",
  patterns: "What patterns stand out across the team?",
  different_steps: "Where do people follow different steps for similar work?",
  people_variation: "Which processes vary most across people?",
  session_summary: "What happened during this session?",
  session_processes: "Which processes were performed?",
  session_time: "Where was most time spent?",
  unusual: "What was unusual compared with similar sessions?",
  baseline: "Also uses similar sessions from the preceding 30 days.",
  unusual_prompt:
    "What was unusual about this session compared with similar sessions? Keep the selected session as the subject. Use recording metadata to find its date and processes, then look outside this single-session scope for accessible sessions containing the same processes in the preceding 30 days. Explain the matching criteria, baseline dates, and sample size. Compare like work, cite the sessions used, and separate observed differences from possible explanations. If there is no adequate baseline, say so. Do not generalize about an entire process or a person from one session.",
  kpi_attention: "Which KPIs need attention?",
  kpi_changed: "What changed since the previous period?",
  kpi_drivers: "What might explain these changes?",
  kpi_processes: "Which processes contribute to these KPI results?",
  build_team: "Build a KPI for this team",
  build_process: "Build a KPI for this process",
  build_kpi: "Build a new KPI",
  create_kpi: "Create KPI",
  compare_processes: "Compare processes",
  compare_help: "Choose two processes to open their visual comparison.",
  compare_dates: "The selected dates apply to both sides.",
  compare_load_error: "Could not load processes for this selection.",
  compare_not_enough:
    "At least two processes with cases are needed. Try different people or a wider date range.",
  choose_first: "First process",
  choose_second: "Second process",
  choose_item: "Choose an item",
  compare_start: "Open comparison",
  kpi_context:
    "Saved KPI definitions and results. Dates identify when evaluations ran, not necessarily their observation periods. Compare only results based on the same definition and scope; distinguish missing/failed evaluations from deteriorating performance. Do not invent historical values or causal explanations.",
  explore_process: "Explore a process",
  explore_help: "Choose a process from this session. Its cases from this session will be selected.",
  choose_process: "Process",
  open_process: "Open process",
  no_processes: "No matching processes are available.",
  no_matching_cases:
    "No cases match this selection on one or both sides. Go back and choose a different process, person, or date range.",
  kpi_question: "What would you like to track?",
  kpi_custom: "Describe your own measure, or edit a starting point below.",
  metric_duration: "Case duration",
  metric_rework: "Repeated work",
  metric_manual: "Manual effort",
  kpi_source_prompt:
    "Source observations: {{source}}. Use these as background for the KPI definition. The recurring KPI must evaluate the selected people and processes over its rolling window, rather than remain restricted to these historical cases.",
  compare_filtered_scope:
    "Selected people and dates apply to both processes. Current case selections are retained for the first process.",
};

export const askItalian: typeof askEnglish = {
  new_chat: "Nuova chat",
  dock: "Mantieni accanto alla pagina",
  overlay: "Mostra sopra la pagina",
  use_page: "Usa i filtri della pagina",
  scope: "Chiedi informazioni su",
  page_overview: "Panoramica",
  page_processes: "Processi",
  page_process: "Processo",
  page_team: "Attività del team",
  page_session: "Sessione",
  page_kpis: "Insight",
  from_page: "da {{page}}",
  context_from_page: "Contesto da {{page}}",
  title_overview: "Chiedi del lavoro del tuo team",
  title_processes: "Scopri cosa approfondire",
  title_process: "Comprendi questo processo",
  title_team: "Esplora come lavora il team",
  title_session: "Comprendi questa sessione",
  title_kpis: "Comprendi i tuoi KPI",
  insight: "Cosa spiega la quota di tempo dedicata a {{process}}?",
  insight_prompt:
    "Cosa spiega la quota di tempo osservato dedicata a {{process}} nell’informazione principale? Distingui numero di casi e durata per caso. Una quota elevata non dimostra inefficienza. Cita le evidenze e la loro copertura.",
  changed: "Cosa è cambiato di più?",
  periods: "{{current}} rispetto a {{previous}}",
  choose_period: "Seleziona un intervallo completo per confrontare i periodi.",
  trend_prompt:
    "Cosa è cambiato di più tra {{current}} e {{previous}}? Usa le persone e i processi selezionati, recuperando il periodo precedente anche se esterno all’intervallo della pagina. Indica entrambi i periodi, copertura e dimensioni del campione. Distingui cambiamenti nella copertura da cambiamenti nel modo di lavorare. Cita le evidenze e segnala dati insufficienti.",
  investigate: "Quali processi dovrei approfondire per primi?",
  opportunity: "Dove si trova la maggiore opportunità di miglioramento?",
  automation: "Dove potrebbero aiutare maggiormente IA o automazione?",
  variation: "Quali processi variano di più nella durata?",
  complexity: "Quali processi hanno i percorsi più complessi?",
  rework: "Dove si osserva più lavoro ripetuto?",
  duration: "Cosa determina la durata di {{process}}?",
  steps: "Quali passaggi richiedono più tempo?",
  process_people: "Come varia questo processo tra le persone?",
  patterns: "Quali schemi emergono nel team?",
  different_steps: "Dove le persone seguono passaggi diversi per lavori simili?",
  people_variation: "Quali processi variano di più tra le persone?",
  session_summary: "Cosa è successo durante questa sessione?",
  session_processes: "Quali processi sono stati svolti?",
  session_time: "Dove è stato impiegato più tempo?",
  unusual: "Cosa è insolito rispetto a sessioni simili?",
  baseline: "Include sessioni simili dei 30 giorni precedenti.",
  unusual_prompt:
    "Cosa è insolito in questa sessione rispetto a sessioni simili? Mantieni la sessione selezionata come soggetto. Trova data e processi nei metadati, poi cerca fuori da questa sessione altre sessioni accessibili con gli stessi processi nei 30 giorni precedenti. Spiega criteri di confronto, date e dimensioni del campione. Confronta lavori simili, cita le sessioni usate e distingui osservazioni da ipotesi. Se manca un confronto adeguato, dichiaralo. Non generalizzare su un processo o una persona da una sola sessione.",
  kpi_attention: "Quali KPI richiedono attenzione?",
  kpi_changed: "Cosa è cambiato dal periodo precedente?",
  kpi_drivers: "Cosa potrebbe spiegare questi cambiamenti?",
  kpi_processes: "Quali processi contribuiscono a questi risultati dei KPI?",
  build_team: "Crea un KPI per questo team",
  build_process: "Crea un KPI per questo processo",
  build_kpi: "Crea un nuovo KPI",
  create_kpi: "Crea KPI",
  compare_processes: "Confronta processi",
  compare_help: "Scegli due processi per aprire il confronto visivo.",
  compare_dates: "Le date selezionate si applicano a entrambi i lati.",
  compare_load_error: "Impossibile caricare i processi per questa selezione.",
  compare_not_enough:
    "Servono almeno due processi con casi. Prova a selezionare altre persone o un intervallo di date più ampio.",
  choose_first: "Primo processo",
  choose_second: "Secondo processo",
  choose_item: "Scegli un elemento",
  compare_start: "Apri confronto",
  kpi_context:
    "Definizioni e risultati dei KPI salvati. Le date indicano quando sono state eseguite le valutazioni, non necessariamente i periodi osservati. Confronta solo risultati con la stessa definizione e lo stesso ambito; distingui valutazioni mancanti o fallite da un peggioramento delle prestazioni. Non inventare valori storici o spiegazioni causali.",
  explore_process: "Esplora un processo",
  explore_help:
    "Scegli un processo di questa sessione. Verranno selezionati i suoi casi di questa sessione.",
  choose_process: "Processo",
  open_process: "Apri processo",
  no_processes: "Nessun processo corrispondente disponibile.",
  no_matching_cases:
    "Nessun caso corrisponde alla selezione su uno o entrambi i lati. Torna indietro e scegli un altro processo, persona o intervallo di date.",
  kpi_question: "Cosa vuoi monitorare?",
  kpi_custom: "Descrivi una misura personalizzata o modifica uno degli spunti qui sotto.",
  metric_duration: "Durata dei casi",
  metric_rework: "Lavoro ripetuto",
  metric_manual: "Attività manuali",
  kpi_source_prompt:
    "Osservazioni di origine: {{source}}. Usale come contesto per la definizione del KPI. Il KPI ricorrente deve valutare le persone e i processi selezionati nella finestra mobile, senza limitarsi a questi casi storici.",
  compare_filtered_scope:
    "Le persone e le date selezionate si applicano a entrambi i processi. La selezione dei casi viene mantenuta per il primo processo.",
};

export const askGerman: typeof askEnglish = {
  new_chat: "Neuer Chat",
  dock: "Neben der Seite behalten",
  overlay: "Über der Seite anzeigen",
  use_page: "Seitenfilter verwenden",
  scope: "Fragen zu",
  page_overview: "Übersicht",
  page_processes: "Prozesse",
  page_process: "Prozess",
  page_team: "Teamaktivität",
  page_session: "Sitzung",
  page_kpis: "Insights",
  from_page: "aus {{page}}",
  context_from_page: "Kontext aus {{page}}",
  title_overview: "Fragen zur Arbeit deines Teams",
  title_processes: "Finde den nächsten Ansatzpunkt",
  title_process: "Verstehe diesen Prozess",
  title_team: "Erkunde die Arbeitsweise deines Teams",
  title_session: "Verstehe diese Sitzung",
  title_kpis: "Verstehe deine KPIs",
  insight: "Was erklärt den Zeitanteil von {{process}}?",
  insight_prompt:
    "Was erklärt den Anteil von {{process}} an der beobachteten Arbeitszeit in der wichtigsten Erkenntnis? Unterscheide Anzahl und Dauer der Fälle. Ein hoher Zeitanteil belegt keine Ineffizienz. Nenne Belege und Datenabdeckung.",
  changed: "Was hat sich am stärksten verändert?",
  periods: "{{current}} gegenüber {{previous}}",
  choose_period: "Wähle einen vollständigen Datumsbereich für den Vergleich.",
  trend_prompt:
    "Was hat sich zwischen {{current}} und {{previous}} am stärksten verändert? Nutze die ausgewählten Personen und Prozesse und rufe den vorherigen Zeitraum auch außerhalb des aktuellen Seitenfilters ab. Nenne beide Zeiträume, Datenabdeckung und Stichprobengrößen. Unterscheide Änderungen der Erfassung von Änderungen der Arbeitsweise. Nenne Belege und unzureichende Daten.",
  investigate: "Welche Prozesse sollte ich zuerst untersuchen?",
  opportunity: "Wo liegt die größte Verbesserungsmöglichkeit?",
  automation: "Wo könnten KI oder Automatisierung am meisten helfen?",
  variation: "Welche Prozesse schwanken am stärksten in der Dauer?",
  complexity: "Welche Prozesse haben die komplexesten Abläufe?",
  rework: "Wo sehen wir die meiste wiederholte Arbeit?",
  duration: "Was bestimmt die Dauer von {{process}}?",
  steps: "Welche Schritte benötigen die meiste Zeit?",
  process_people: "Wie unterscheidet sich dieser Prozess zwischen Personen?",
  patterns: "Welche Muster fallen im Team auf?",
  different_steps: "Wo nutzen Personen unterschiedliche Schritte für ähnliche Arbeit?",
  people_variation: "Welche Prozesse unterscheiden sich am stärksten zwischen Personen?",
  session_summary: "Was ist in dieser Sitzung passiert?",
  session_processes: "Welche Prozesse wurden ausgeführt?",
  session_time: "Wofür wurde die meiste Zeit aufgewendet?",
  unusual: "Was war im Vergleich zu ähnlichen Sitzungen ungewöhnlich?",
  baseline: "Bezieht ähnliche Sitzungen der vorherigen 30 Tage ein.",
  unusual_prompt:
    "Was war an dieser Sitzung gegenüber ähnlichen Sitzungen ungewöhnlich? Behalte die gewählte Sitzung als Gegenstand bei. Ermittle Datum und Prozesse aus den Metadaten und suche außerhalb dieser Sitzung nach zugänglichen Sitzungen mit denselben Prozessen in den vorherigen 30 Tagen. Erkläre Auswahlkriterien, Vergleichsdaten und Stichprobengröße. Vergleiche ähnliche Arbeit, zitiere die verwendeten Sitzungen und trenne Beobachtungen von möglichen Erklärungen. Sage ausdrücklich, wenn keine ausreichende Vergleichsbasis vorliegt. Verallgemeinere nicht von einer Sitzung auf einen ganzen Prozess oder eine Person.",
  kpi_attention: "Welche KPIs benötigen Aufmerksamkeit?",
  kpi_changed: "Was hat sich seit dem vorherigen Zeitraum verändert?",
  kpi_drivers: "Was könnte diese Änderungen erklären?",
  kpi_processes: "Welche Prozesse tragen zu diesen KPI-Ergebnissen bei?",
  build_team: "KPI für dieses Team erstellen",
  build_process: "KPI für diesen Prozess erstellen",
  build_kpi: "Neuen KPI erstellen",
  create_kpi: "KPI erstellen",
  compare_processes: "Prozesse vergleichen",
  compare_help: "Wähle zwei Prozesse für den visuellen Vergleich.",
  compare_dates: "Die ausgewählten Daten gelten für beide Seiten.",
  compare_load_error: "Prozesse für diese Auswahl konnten nicht geladen werden.",
  compare_not_enough:
    "Es werden mindestens zwei Prozesse mit Fällen benötigt. Wähle andere Personen oder einen größeren Zeitraum.",
  choose_first: "Erster Prozess",
  choose_second: "Zweiter Prozess",
  choose_item: "Eintrag auswählen",
  compare_start: "Vergleich öffnen",
  kpi_context:
    "Gespeicherte KPI-Definitionen und Ergebnisse. Die Daten zeigen den Auswertungszeitpunkt, nicht zwingend den Beobachtungszeitraum. Vergleiche nur Ergebnisse mit gleicher Definition und gleichem Datenumfang. Unterscheide fehlende oder fehlgeschlagene Auswertungen von schlechterer Leistung. Erfinde keine historischen Werte oder kausalen Erklärungen.",
  explore_process: "Prozess erkunden",
  explore_help:
    "Wähle einen Prozess aus dieser Sitzung. Seine Fälle aus dieser Sitzung werden ausgewählt.",
  choose_process: "Prozess",
  open_process: "Prozess öffnen",
  no_processes: "Keine passenden Prozesse verfügbar.",
  no_matching_cases:
    "Auf einer oder beiden Seiten gibt es keine passenden Fälle. Gehe zurück und wähle einen anderen Prozess, eine Person oder einen Zeitraum.",
  kpi_question: "Was möchtest du verfolgen?",
  kpi_custom: "Beschreibe eine eigene Kennzahl oder bearbeite einen Vorschlag unten.",
  metric_duration: "Falldauer",
  metric_rework: "Wiederholte Arbeit",
  metric_manual: "Manuelle Arbeit",
  kpi_source_prompt:
    "Ausgangsbeobachtungen: {{source}}. Nutze sie als Hintergrund für die KPI-Definition. Der wiederkehrende KPI soll die ausgewählten Personen und Prozesse im rollierenden Zeitraum auswerten und nicht auf diese historischen Fälle beschränkt bleiben.",
  compare_filtered_scope:
    "Ausgewählte Personen und Daten gelten für beide Prozesse. Die Fallauswahl bleibt für den ersten Prozess erhalten.",
};
